$(function () {
  $('form#new_asap_file_import').on('change', function () {
    const disabled = $(this).find('.disable-upload:input').filter(function () {
      return !$(this).val();
    }).length != 0;
    $('#asap-upload-modal-btn').attr('disabled', disabled);
  });

  $('form#new_asap_file_import').on('change', function () {
    const fileName = $('#asap-file-upload-input').val();
    const importFile = $('#asap_file_import_asap_file')[0].files[0];

    if (importFile) {
      const importFileSizeBytes = importFile.size;
      const maxFileSizeMb = parseInt($('#asap-file-max-size').attr('data-asap-file-max-size'));
      const maxFileSizeBytes = maxFileSizeMb * 1024 * 1024;

      if (importFileSizeBytes > maxFileSizeBytes) {
        alert(`File too large: ASAP files must be less than ${maxFileSizeMb} MB. "${fileName}" is ${(importFileSizeBytes / (1024 * 1024)).toFixed(2)} MB.`);
        $('#asap_file_import_asap_file').val('');
        $('#asap-file-upload-input').val('');
        return;
      }
    }
  });

  $('#file-upload-btn').on('click', function () {
    $('#confirmationDialog').modal('toggle');
  });
});
